<template>
  <div v-if="!isMobile()">
  <NavBar></NavBar>
  <header  class="page-header" >
  <div class="container">
  </div>
  </header>
  <main>
    <div style="text-align: center; padding-top: 100px;padding-bottom: 100px;">
 <img :src="imgPath + 'images/404.jpg'" alt="1000X1000" style="width: 35%;" />
</div>
    <SiteFooter></SiteFooter>
  </main>
  </div>
  <div v-else>
    <NavBarmob></NavBarmob>
    <header  class="page-header" >
  <div class="container">
  </div>
  </header>
    <main>
        <div style="text-align: center;min-height: 350px;">
 <img :src="imgPath + 'images/404.jpg'" alt="1000X1000" style="width: 35%;
  padding-top: 40px;" />
</div>
        <IndexFooter></IndexFooter>
        </main>
</div>
</template>
<script>
import NavBar from "../UI/NavBar.vue";
import SiteFooter from "../UI/SiteFooter.vue";
import NavBarmob from '../UI/NavBarmob.vue';
import IndexFooter from '../Indexmobile/IndexFooter.vue';
export default {
components: {
  NavBar,
  SiteFooter,
  NavBarmob,
  IndexFooter
},
data() {
    return {
      imgPath: process.env.BASE_URL,

    }
  },
methods: {
 isMobile() {
   if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
     return true
   } else {
     return false
   }
 }
}
}
</script>